import React from "react"
import { view } from "react-easy-state"
import { isMobile } from "react-device-detect"
import { Select, Input, Row, Col } from "antd"

import Header from "components/common/layouts/Header"
import Footer from "components/common/layouts/Footer"
import ContentLoader from "components/common/ContentLoader"
import ContentLoadingFailed from "components/common/ContentLoadingFailed"
import CourseList from "components/pages/students/courses/index/CourseList"

import globalStore from "store"

import CoursesService from "services/students/courses.service"

const topbarFilterLeftColSpan = {
  xs: { span: 24 },
  sm: { span: 16 },
  md: { span: 18 },
}

const topbarFilterRightColSpan = {
  xs: { span: 24 },
  sm: { span: 8 },
  md: { span: 6 },
}

class CoursesIndexPage extends React.Component {
  async fetchData() {
    const pageState = globalStore.ui.students.courses.index
    await CoursesService.index({ pageState })
  }

  async componentDidMount() {
    await this.fetchData()
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      this.state.refresh !== prevState.refresh &&
      this.state.refresh === true
    ) {
      await this.fetchData()
      this.setState({ refresh: false })
    }
  }

  renderPageContent() {
    const pageState = globalStore.ui.students.courses.index
    const {
      course_invitations,
      subscribed_courses,
      courses,
      API_COURSES_INDEX_STATUS,
    } = pageState

    if (!API_COURSES_INDEX_STATUS) return <ContentLoader />
    if (API_COURSES_INDEX_STATUS === "pending") return <ContentLoader />
    if (API_COURSES_INDEX_STATUS === "rejected") return <ContentLoadingFailed />

    return (
      <React.Fragment>
        {subscribed_courses && subscribed_courses.length > 0 && (
          <CourseList courses={subscribed_courses} title="My Courses" />
        )}
        {courses && courses.length > 0 && (
          <CourseList
            courses={courses}
            title="All Courses"
            subscribable
            course_invitations={course_invitations}
            refresh={() => this.setState({ refresh: true })}
          />
        )}
      </React.Fragment>
    )
  }

  render() {
    const filterRow = (
      <div className="topbar-filter">
        <Row>
          <Col {...topbarFilterLeftColSpan} className="m-t-20">
            <div className="left-items">
              <div>
                <span>Category: </span>
                <Select defaultValue="all">
                  <Select.Option value="all">All</Select.Option>
                </Select>
              </div>
              <div>
                <span>Author: </span>
                <Select defaultValue="all">
                  <Select.Option value="all">All</Select.Option>
                </Select>
              </div>
            </div>
          </Col>
          <Col {...topbarFilterRightColSpan} className="m-t-20">
            <Input type="search" placeholder="Find a course" />
          </Col>
        </Row>
      </div>
    )

    return (
      <div className={`page course-page ${isMobile ? "mobile" : ""}`}>
        <Header />
        <div className="page-content">
          {false && filterRow}
          {this.renderPageContent()}
        </div>
        <Footer />
      </div>
    )
  }
}

export default view(CoursesIndexPage)
